import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1288158062997995';
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.fbq) {
      // Ya inicializado — solo disparamos PageView
      window.fbq('track', 'PageView');
      return;
    }
    // Snippet oficial de Meta Pixel
    ;
    (function (f: any, b: Document, e: string, v: string) {
      let n: any;
      let t: HTMLScriptElement;
      let s: HTMLScriptElement;
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0] as HTMLScriptElement;
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        ;
        (b.head || b.body || b.documentElement).appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
    // <noscript> fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      if (noscript.parentNode) noscript.parentNode.removeChild(noscript);
    };
  }, []);
  return null;
}